import Component from '@ember/component';
import { action } from '@ember/object';

export default Component.extend({
  refreshBrowser: action(function () {
    window.location.reload();
  }),
});
